import React, { useState } from 'react';
import {
  Text,
  Row,
  Col,
  ButtonIcon,
  Tooltip,
  Select,
} from '@cubeyou-team/hx-react-components';

import translations from 'src/lang';
import { getTimeframesOptions } from 'src/utils/misc';

import { StyledTimeframeSelector } from './TimeframeSelector.styles';

const TimeframeSelector = ({
  timeframes,
  selectedTimeframe,
  onTimeframeChange,
}) => {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <StyledTimeframeSelector>
      <Row valign="middle">
        <Col span="auto">
          <Text size="small">Audience timeframe:</Text>
        </Col>
        <Col span="auto">
          <Tooltip
            position="bottom"
            content={translations['en-US'].QUERY_BUILDER.audienceTimeframeInfos}
          >
            <ButtonIcon size="small" icon="informations" />
          </Tooltip>
        </Col>
        <Col span={!isEditing ? 'auto' : 2}>
          {isEditing ? (
            !timeframes.isLoading && (
              <Select
                size="thin"
                options={getTimeframesOptions(
                  timeframes.data,
                  selectedTimeframe
                )}
                onItemChange={value => {
                  onTimeframeChange(value);
                  setIsEditing(false);
                }}
              />
            )
          ) : (
            <Text size="small" weight="bold">
              Last {selectedTimeframe} weeks
            </Text>
          )}
        </Col>
        <Col span="auto">
          <ButtonIcon
            icon={!isEditing ? 'edit' : 'remove'}
            size="small"
            onClick={() => setIsEditing(!isEditing)}
          />
        </Col>
      </Row>
    </StyledTimeframeSelector>
  );
};

export default TimeframeSelector;
